import { SravniNewsSharedEnumsMaterialType } from '../__generated__/news/Api';
import { TRubricType } from '../interfaces/news';

export const TAKE_MATERIALS = 6;
export const TAKE_AMP_MATERIALS = 15;
export const TAKE_MATERIALS_INITIAL = 12;
export const TAKE_NEWS_INITIAL = TAKE_MATERIALS_INITIAL;

export const TAKE_ADDITIONAL_READING_MOBILE = 2;
export const TAKE_ADDITIONAL_READING = 3;

export const URL_TYPES = {
  [SravniNewsSharedEnumsMaterialType.News]: 'novost',
  [SravniNewsSharedEnumsMaterialType.PrivateNews]: 'novost',
  [SravniNewsSharedEnumsMaterialType.Article]: 'text',
  [SravniNewsSharedEnumsMaterialType.PrivateArticle]: 'text',
};

export const NEWS_TYPES = [SravniNewsSharedEnumsMaterialType.News, SravniNewsSharedEnumsMaterialType.PrivateNews];

export const NEWS_URL_TYPES = [
  URL_TYPES[SravniNewsSharedEnumsMaterialType.News],
  URL_TYPES[SravniNewsSharedEnumsMaterialType.PrivateNews],
];

export const SPORT_RUBRICS = ['sport'];

export const NEWS_RUBRICS = ['novosti', 'novosti-partnerov'];

export const PRODUCT_RUBRIC_MAP: { [key: string]: TRubricType } = {
  strakhovanie: 'strahovki',
};

export const TAGS_MAX_LENGTH = 3;

export enum MATERIAL_TAG {
  GAMES = 'Игры',
  CALCS = 'Калькуляторы',
  TESTS = 'Тесты',
}

export enum FILTERS_NAMES {
  TEXT = 'text',
  TAG = 'tag',
}

export type FILTERS = {
  [FILTERS_NAMES.TEXT]?: string;
  [FILTERS_NAMES.TAG]?: string[];
};

export const SUBDOMAIN_RUBRICS_PARAMS = { ignoreMenuOrder: true, includePrivate: true };
